/**
 * ns.wow Page Navigation
 * Facade class for public accessible core functionality.
 */

class Plugin {

  init() {
    // nothing to do right now
  }

}

export default new Plugin();
